/** Work and feature clients always resolve full `/api/...` paths on this origin. */
export const SAME_ORIGIN_API_BASE = '' as const;
